module.exports = __webpack_public_path__ + "static/media/humanHeadIcon.5c25066d.svg";